export default {
  wrapper: {
    px: '12px',
    pl: '21px',
    justifyContent: 'center',
    display: 'flex',
  },
  collapsed: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '39px',
    height: '39px',
    backgroundColor: '#F1F5F4',
    mx: 'auto',
    borderRadius: '50%',
  },
};
